import { Modal } from '~/components/Modal'

export const BugReportModal: React.FC = () => {
  return (
    <Modal>
      <Modal.Header>Hey</Modal.Header>
    </Modal>
  )
}
